export enum LIGHT_TYPES {
    DIRECTIONAL = "directional",
    AMBIENT = "ambient"
}

export interface Light {
    type: LIGHT_TYPES;
    intensity: number;
    color: number;
    position?: {
        x: number;
        y: number;
        z: number;
    };
}
